import { render, staticRenderFns } from "./CategoryDemandInactive.vue?vue&type=template&id=679c6c8c&scoped=true"
import script from "./CategoryDemandInactive.vue?vue&type=script&lang=js"
export * from "./CategoryDemandInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c6c8c",
  null
  
)

export default component.exports